import { render, staticRenderFns } from "./BCXPdfPopup.vue?vue&type=template&id=0aaab9bc&scoped=true"
import script from "./BCXPdfPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXPdfPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXPdfPopup.vue?vue&type=style&index=0&id=0aaab9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaab9bc",
  null
  
)

export default component.exports